const Immersive3dTourFloorPlanImportStatus = {
  NEW: 0,
  QUEUED: 1,
  DONE: 2,
};

export default Immersive3dTourFloorPlanImportStatus;
